export default {
    notifications: "Notifications",
    "no-notifications": "You have no notifications yet.",
    "load-more": "Load more",
    "clear-all": "Clear all",
    "see-all": "See all notifications",
};
